import dayjs from "dayjs";
import { useEffect, useState } from "react";

import { useLoader } from "@/contexts/loader";
import { useGetQueueDriverPositionQuery } from "@/store/apis/nextcargo";

export type DriverGetQueuePositionData = ReturnType<typeof useGetQueueDriverPositionQuery> & {
  isDriverActionsBlocked: boolean;
};

/**
 * @property {string} [driverId]
 */
export function useDriverGetQueuePosition(driverId: string): DriverGetQueuePositionData {
  const { setLoading } = useLoader();
  const [isDriverActionsBlocked, setIsDriverActionsBlocked] = useState(false);

  const apiState = useGetQueueDriverPositionQuery({ id: Number(driverId) }, { skip: !driverId });

  useEffect(() => {
    if (apiState.isSuccess) {
      const queueDate = apiState.data?.queue.date;
      const isDriverActionsBlocked = blockDriverActions({
        appointmentTime: queueDate
      });

      setIsDriverActionsBlocked(isDriverActionsBlocked);
    }
  }, [apiState.isSuccess]);

  useEffect(() => {
    if (apiState.isLoading) {
      setLoading(true);
    } else {
      setLoading(false);
    }
  }, [apiState.isLoading]);

  return {
    ...apiState,
    isDriverActionsBlocked
  };
}

function blockDriverActions({ appointmentTime }: { appointmentTime: string }): boolean {
  const now = dayjs();
  const appointment = dayjs(appointmentTime);

  const minutes = appointment.diff(now, "minute");

  const SIX_HOURS_IN_MINUTES = 6 * 60; // 360 min
  const isDriverActionsBlocked = minutes <= SIX_HOURS_IN_MINUTES;
  return isDriverActionsBlocked;
}
